import React from 'react';

const CancelMessage = ({ showCancel }) => (
  <div className="card card--warning">
    <div className="card__content">
      <p>
        {`Thanks for returning your equipment! If you haven't already changed${showCancel ? ' or canceled' : ''} your
        service, we'll need the primary account holder to confirm. Please call us at `}
        <span data-notranslate>1-800-COMCAST</span>
        .
      </p>
    </div>
  </div>
);

export default CancelMessage;
